<template>
    <breadCrumbs title="Dropzone" main="Bonus UI" title1="Dropzone" />
    <div class="container-fluid">
      <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header pb-0">
                <h3>Single File Upload</h3>
              </div>
              <div class="card-body">
                <DropZone class="text-center" :maxFileSize="Number(60000000)" url="http://localhost:8080" :uploadOnDrop="true" :multipleUpload="true" :parallelUpload="2" />
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header pb-0">
                <h3>Multi File Upload</h3>
              </div>
              <div class="card-body">
                <DropZone class="text-center" :maxFileSize="Number(60000000)" url="http://localhost:8080" :uploadOnDrop="true" :multipleUpload="true" :parallelUpload="2" />
              </div>
            </div>
          </div>
          
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header pb-0">
                <h3>File Type Validation</h3>
              </div>
              <div class="card-body">
                <DropZone class="text-center" :maxFileSize="Number(60000000)" url="http://localhost:8080" :uploadOnDrop="true" :multipleUpload="true" :parallelUpload="2" />
              </div>
            </div>
          </div>
        </div>
      </div>
</template>